"use client"

import { useMemo, useEffect } from "react"
import type { CommunityPost } from "../types"
import { usePostStore } from "../store/post-store"
import { useUserStore } from "../store/user-store"
import { denormalizePost } from "../normalize"
import { loadPostDetail } from "../service/post-service"

export function usePost(postId: string | undefined): {
  post: CommunityPost | undefined
  loading: boolean
} {
  const normalized = usePostStore((s) => (postId ? s.entities[postId] : undefined))
  const author = useUserStore((s) =>
    normalized ? s.entities[normalized.authorId] : undefined,
  )

  const loading = postId ? !normalized || !author : false

  useEffect(() => {
    if (!postId) return
    loadPostDetail(postId)
  }, [postId])

  const post = useMemo(() => {
    if (!normalized || !author) return undefined
    return denormalizePost(normalized, author)
  }, [normalized, author])

  return { post, loading }
}
